import React, { useState, useEffect } from "react";
import Audience from "../../components/manager/audience";
import AddAudience from "../../components/manager/audience/addAudience";
import { getTopAutoGenCohortsbyTagID } from "../../services/cohort";
import { getSession } from "../../services/auth";
import Loader from "../misc/loader";
import { isReadOnly as computeReadOnly } from "../../utilities/permissions";

function TopAudiences() {
	const [tagId, setTagId] = useState(localStorage.getItem("activeSilo"));
	const [publisherSettings, setPublisherSettings] = useState(localStorage.getItem("publisherSettings"));
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [currency, setCurrency] = useState("USD");
	const [exchangeRate, setExchangeRate] = useState(1.0);
	const [readOnly, setReadOnly] = useState(false);
	const verifyAccess = async () => {
		const session = getSession();
		if (!session) return;
		
		const settings = await JSON.parse(publisherSettings) ?? {};
		let amsFlavorValue = settings.ams_flavor ?? "full";
		setCurrency(settings.display_currency ? settings.display_currency.symbol : "USD");
		setExchangeRate(settings.display_currency ? settings.display_currency.exchangeRate : 1.0);
		let isReadOnly = computeReadOnly(session.role_id);
		setReadOnly(isReadOnly);
			if (tagId) {
				await getTopAutoGenCohortsbyTagID(tagId, amsFlavorValue).then((_cohorts) => {
					const stripped = Object.entries(_cohorts.data).map((el) => el[1]);
					const transform = stripped.filter((el) => (el.auto_generated == true)).map((el) => ({
						...el,
						unique_users: el.metrics.last30Days.uniqueUsers,
						value: el.metrics.last30Days.averagePrebidCpm,
						interests: el.contextual_page_semantic
							? el.contextual_page_semantic
									.filter((el) => (el.type = "categories"))
									.map((el) => el.categories)
							: null,
					}));
					const dataset = transform.sort((a, b) => (a.unique_users < b.unique_users ? 1 : -1));
					setData(dataset.slice(0, isReadOnly ? 5 : 4));
					setLoading(_cohorts == null);
				});
			}
	};

	useEffect(() => {
		window.addEventListener("storage", () => {
			setTagId(localStorage.getItem("activeSilo"));
			setPublisherSettings(localStorage.getItem("publisherSettings"));
		});
	}, []);

	useEffect(() => {
		verifyAccess();
	}, [tagId, publisherSettings]);

	return (
		<div className="audience-blocks">
			{loading ? (
				<Loader size="xl" />
			) : (
				<>
					{data.map((el, i) => (
						<Audience
							key={i}
							title={el.name}
							interests={el.interests ? el.interests[0] : null}
							value={el.value}
							users={el.unique_users}
							id={el.unique_id}
							currency={currency}
							exchangeRate={exchangeRate}
						/>
					))}
					{!readOnly && (
						<AddAudience />
					)}
				</>
			)}
		</div>
	);
}

export default TopAudiences;
